import React, { useEffect, useState, useCallback } from 'react'

import alumni_json from './static/alumni_8-7-25.json'
import categories_json from './static/categories_8-5-25.json'
import accolades_json from './static/accolades_11-7-25.json'
import mentions_json from './static/mentions_4-3-25.json'
import { normalizeName } from './components/utils';


const Context = React.createContext();

var Airtable = require('airtable');

function Provider({ children }) {



  const [alumni, setAlumni] = useState([...alumni_json])
  const [categories, setCategories] = useState([...categories_json])
  const [accolades, setAccolades] = useState([...accolades_json])
  const [mentions, setMentions] = useState([...mentions_json])

  const [filterCategories, setFilterCategories] = useState();
  const [openToWork, setOpenToWork] = useState(true);



  const fetchAlumni = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/.netlify/functions/fetchAlumni`);
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(`Network response was not ok: ${errorData.details || response.statusText}`);
      }
      const results = await response.json();
      console.log('alumni = ', results);
      setAlumni(results);
    } catch (error) {
      console.error('Error fetching records:', {
        message: error.message,
        type: error.name,
        status: error.status
      });
    }
  }, []);



  const fetchCategories = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/.netlify/functions/fetchCategories`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const results = await response.json();
      console.log('cats = ', results);
      if (Array.isArray(results)) setCategories(results);
    } catch (error) {
      console.error('Error fetching records:', error);
    }
  }, []);

  const fetchAccolades = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/.netlify/functions/fetchAccolades`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const results = await response.json();
      console.log('accs = ', results);
      if (Array.isArray(results)) setAccolades(results);
    } catch (error) {
      console.error('Error fetching records:', error);
    }
  }, []);

  const fetchMentions = useCallback(async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/.netlify/functions/fetchMentions`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const results = await response.json();
      console.log('accs = ', results);
      if (Array.isArray(results)) setMentions(results);
    } catch (error) {
      console.error('Error fetching records:', error);
    }
  }, []);




  useEffect(() => {
    if (Object.keys(alumni).length === 0) {
      fetchAlumni();
    }
  }, [fetchAlumni]);

  useEffect(() => {
    if (Object.keys(alumni).length > 0 && Object.keys(categories).length === 0) {
      fetchCategories();
    }
  }, [alumni, categories, fetchCategories]);

  useEffect(() => {
    if (Object.keys(alumni).length > 0 && Object.keys(categories).length === 0) {
      fetchMentions();
    }
  }, [alumni, mentions, fetchMentions]);

  useEffect(() => {
    if (Object.keys(accolades).length === 0) {
      fetchAccolades();
    }
  }, [fetchAccolades]);


  const [ready, setReady] = useState(false)
  // useEffect(() => {
  //   if (data && data.length) {
  //     setReady(true);
  //   }
  // }, [data])
  useEffect(() => {
    if (alumni && alumni.length) {
      setReady(true);
    }
  }, [alumni])



  const getAlumniByHandle = (handle) => {
    return alumni.find(one => one.handle === `${handle}`);
  }
  const getAccoladeById = (id) => {
    return accolades.find(one => one._id === `${id}`);
  }
  const getMentionById = (id) => {
    return mentions.find(one => one._id === `${id}`);
  }




  return (<>
    <Context.Provider
      value={{
        state: {
          ready,
          filterCategories,
          setFilterCategories,
          openToWork,
          setOpenToWork,
        },
        accolades: accolades,
        mentions: mentions,
        alumni: alumni,
        categories: categories,
        handles: {
        },
        x: {
          getAlumniByHandle,
          getAccoladeById,
          getMentionById,
        }
      }}
    >
      {children}
    </Context.Provider>
  </>
  )

}

const Consumer = Context.Consumer;

export { Context, Provider, Consumer };
